import { allStaticPages } from 'content-collections'
import type { StaticPage } from 'content-collections'

/**
 * Get a static page by slug and locale
 * @param slug - The page slug (e.g., 'privacy', 'terms')
 * @param locale - The locale (e.g., 'en', 'de')
 * @returns The static page content or undefined if not found
 */
export function getStaticPage(slug: string, locale: string) {
  // Normalize locale to base language (e.g., 'en-US' -> 'en')
  const normalizedLocale = locale.split('-')[0]
  
  const page = allStaticPages.find(
    (p: StaticPage) => p.slug === slug && p.locale === normalizedLocale
  )
  
  // Fallback to English if locale not found
  if (!page && normalizedLocale !== 'en') {
    return allStaticPages.find((p: StaticPage) => p.slug === slug && p.locale === 'en')
  }
  
  return page
}

/**
 * Get all static pages for a specific locale
 * @param locale - The locale (e.g., 'en', 'de')
 * @returns Array of static pages
 */
export function getStaticPagesByLocale(locale: string) {
  const normalizedLocale = locale.split('-')[0]
  return allStaticPages.filter((p: StaticPage) => p.locale === normalizedLocale)
}
